import { render, staticRenderFns } from "./kilometer-course-badge.vue?vue&type=template&id=b7255ff0&scoped=true"
import script from "./kilometer-course-badge.vue?vue&type=script&lang=js"
export * from "./kilometer-course-badge.vue?vue&type=script&lang=js"
import style0 from "./kilometer-course-badge.vue?vue&type=style&index=0&id=b7255ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7255ff0",
  null
  
)

export default component.exports